import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const billingState = (state: RootState) => state.scene.billing;

export const isLoading = createSelector(billingState, ({ loading }) => loading);

export const isAnnual = createSelector(billingState, ({ annual }) => annual);

export const isCheckoutModalVisible = createSelector(
  billingState,
  ({ checkoutModalVisible }) => checkoutModalVisible
);

export const isUpgradeLoading = createSelector(
  billingState,
  ({ upgradeLoading }) => upgradeLoading
);

export const isSuccessState = createSelector(
  billingState,
  ({ showSuccessState }) => showSuccessState
);

export const getStripe = createSelector(billingState, ({ stripe }) => stripe);

export const getTiers = createSelector(billingState, ({ tiers }) => tiers);

export const getCurrentPlan = createSelector(billingState, ({ currentPlan }) => currentPlan);
export const getSelectedTier = createSelector(billingState, ({ selectedTier }) => selectedTier);
export const getMinimalTier = createSelector(billingState, ({ minimalTier }) => minimalTier);
export const getLicenses = createSelector(billingState, ({ licenses }) => licenses);
export const getPriceInfo = createSelector(billingState, ({ priceInfo }) => priceInfo);

export const getAddOns = createSelector(billingState, ({ addOns }) => addOns);
export const getSelectedAddOn = createSelector(billingState, ({ selectedAddOn }) => selectedAddOn);
